export default "/images/vendor/flag-icon-css/flags/4x3/dm.svg?cfce36343ac21f15429805843bf2381d";